"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppConfig = void 0;
const class_validator_1 = require("class-validator");
const cloneModelObject_1 = require("../util/cloneModelObject");
const errorTypes_1 = require("../helpers/errorTypes");
/**
 * Model used for setting and validating app configs
 */
class AppConfig {
    constructor() {
        this.useRealClient = false;
        this.helpEmail = "support@nextpracticehealth.com";
        this.persistSessionOnLoad = true;
        this.serialize = () => {
            return {
                theme: this.theme,
                useRealClient: this.useRealClient,
                environment: this.environment,
                servicesUrl: this.servicesUrl,
                webViewsUri: this.webViewsUri,
                atlassianServiceDeskKey: this.atlassianServiceDeskKey,
                helpEmail: this.helpEmail,
                persistSessionOnLoad: this.persistSessionOnLoad,
                debugChaosProbability: this.debugChaosProbability,
                debugRequestErrorCount: this.debugRequestErrorCount,
                debugClientMethodsError: this.debugClientMethodsError,
                debugErrorApproach: this.debugErrorApproach
            };
        };
    }
    static unserialize(data) {
        const config = new this();
        config.theme = data.theme;
        config.useRealClient = data.useRealClient;
        config.environment = data.environment;
        config.servicesUrl = data.servicesUrl;
        config.webViewsUri = data.webViewsUri;
        config.atlassianServiceDeskKey = data.atlassianServiceDeskKey;
        config.helpEmail = data.helpEmail;
        config.persistSessionOnLoad = data.persistSessionOnLoad;
        config.debugChaosProbability = data.debugChaosProbability;
        config.debugRequestErrorCount = data.debugRequestErrorCount;
        config.debugClientMethodsError = data.debugClientMethodsError;
        config.debugErrorApproach = data.debugErrorApproach;
        return config;
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    validate() {
        const validated = (0, class_validator_1.validateSync)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], AppConfig.prototype, "theme", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)()
], AppConfig.prototype, "useRealClient", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], AppConfig.prototype, "environment", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], AppConfig.prototype, "servicesUrl", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], AppConfig.prototype, "webViewsUri", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
], AppConfig.prototype, "atlassianServiceDeskKey", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
], AppConfig.prototype, "helpEmail", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)()
], AppConfig.prototype, "persistSessionOnLoad", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1)
], AppConfig.prototype, "debugChaosProbability", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsPositive)()
], AppConfig.prototype, "debugRequestErrorCount", void 0);
__decorate([
    (0, class_validator_1.IsOptional)()
], AppConfig.prototype, "debugClientMethodsError", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)()
], AppConfig.prototype, "debugErrorApproach", void 0);
exports.AppConfig = AppConfig;
//# sourceMappingURL=AppConfig.js.map